module.exports = __webpack_public_path__ + "static/img/jeans_r.216c116c.webp";